import React, { useEffect, useCallback, useState} from 'react';
import { Grid } from 'semantic-ui-react';
import ReconForm from '../reconForm/index';
import ReconHeader from '../reconHeader';
import { useSelector, useDispatch } from 'react-redux'
import useGetFormData from '../../hooks/useGetFormData';
import ReconStatusDetail from '../reconStatusDetail/ReconStatusDetail';

const ReconJob = () => {
  const [screenSize, setScreenSize] = useState(1000);
  const [showStatusDetail, setShowStatusDetail] = useState(false);
  const {currentJob} = useSelector((state) => state.currentJob);
  const onWindowResize = useCallback(() => {
    setScreenSize(window.innerHeight);
  }, [setScreenSize]);

  const {getFormData} = useGetFormData();

  useEffect(() => {
    window.addEventListener("resize", onWindowResize)
    onWindowResize();
    getFormData();
    return () => {
      window.removeEventListener("resize", onWindowResize)
    }
  }, [])

  return (
    <Grid style={{height: screenSize - 50,alignContent: 'flex-start'}}>
      <Grid.Row className='recon-header'>
        <Grid.Column>
          <ReconHeader showStatusDetail={showStatusDetail} setShowStatusDetail={setShowStatusDetail} currentJob={currentJob} />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row className='recon-form'>
        <Grid.Column>
          {showStatusDetail ? 
            <ReconStatusDetail /> :
            <ReconForm />
          }
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default ReconJob;
